import React, { CSSProperties } from "react";

interface LoaderProps {
  isLoading: boolean;
  progress?: number | null;
}

const Loader: React.FC<LoaderProps> = ({ isLoading, progress = null }) => {
  if (!isLoading) return null;

  return (
    <>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <div style={styles.loaderContainer}>
        <div style={styles.loaderContent}>
          {progress !== null ? (
            <div style={styles.progressContainer}>
              <svg width="80" height="80" viewBox="0 0 100 100">
                <circle
                  cx="50"
                  cy="50"
                  r="40"
                  stroke="#e0e0e0"
                  strokeWidth="8"
                  fill="none"
                />
                <circle
                  cx="50"
                  cy="50"
                  r="40"
                  stroke="#0092d5"
                  strokeWidth="8"
                  fill="none"
                  strokeDasharray="251.2"
                  strokeDashoffset={251.2 - (progress / 100) * 251.2}
                  strokeLinecap="round"
                  style={{ transition: "stroke-dashoffset 0.3s ease" }}
                />
                <text
                  x="50"
                  y="55"
                  textAnchor="middle"
                  fontSize="18"
                  fill="black"
                >
                  {progress}%
                </text>
              </svg>
            </div>
          ) : (
            <>
              <div className="overlay">&nbsp;</div>
              <div className="loading">
                <div className="laderWrapper">
                  <svg viewBox="0 0 20 20" preserveAspectRatio="xMidYMid meet">
                    <polyline
                      id="back"
                      points="2 10 5 10 7 15 11 5 13 10 17 10"
                    ></polyline>
                    <polyline
                      id="front"
                      points="2 10 5 10 7 15 11 5 13 10 17 10"
                    ></polyline>
                  </svg>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

const styles: { [key: string]: CSSProperties } = {
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    zIndex: 1000,
    backdropFilter: "blur(5px)",
  },
  loaderContent: {
    textAlign: "center",
  },
  spinner: {
    width: "3rem",
    height: "3rem",
    borderWidth: "0.25rem",
    animation: "spin 1s linear infinite",
  },
  progressContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};

export default Loader;
